import { useCallback, useEffect, useState } from 'react';

import { useHttpContext } from '@sayyesschool/frontend/clients/http';
import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import LoadingIndicator from '@sayyesschool/frontend/components/loading-indicator';
import Page from '@sayyesschool/frontend/components/page';

import MembershipPackForm from '@/components/memberships/membership-pack-form';
import MembershipPacksTable from '@/components/memberships/membership-packs-table';

export default function MembershipPacksPage() {
    const { http } = useHttpContext();

    const [packs, setPacks] = useState(null);
    const [pack, setPack] = useState(null);
    const [isDialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {
        http.request({ method: 'get', path: '/memberships/packs' })
            .then(({ data }) => setPacks(data));
    }, [http]);

    const createPack = useCallback(data => {
        return http.request({ method: 'post', path: '/memberships/packs', data })
            .then(({ data }) => {
                setPacks(packs => packs.concat(data));
                setDialogOpen(false);
            });
    }, [http]);

    const togglePack = useCallback(pack => {
        return http.request({
            method: 'put',
            path: `/memberships/packs/${pack.id}`,
            data: { ...pack, active: !pack.active }
        }).then(({ data }) => {
            setPacks(packs => packs.map(p => p.id === data.id ? data : p));
            setPack(data);
            setDialogOpen(false);
        });
    }, [http]);

    const updatePack = useCallback(data => {
        return http.request({
            method: 'put',
            path: `/memberships/packs/${pack.id}`,
            data: { id: pack.id, ...data }
        }).then(({ data }) => {
            setPacks(packs => packs.map(p => p.id === data.id ? data : p));
            setPack(data);
            setDialogOpen(false);
        });
    }, [pack, http]);

    const deletePack = useCallback(pack => {
        return http.request({ method: 'delete', path: `/memberships/packs/${pack.id}` })
            .then(({ data }) => {
                setPacks(packs => packs.filter(p => p.id !== data.id));
            });
    }, [http]);

    const handleCreate = useCallback(() => {
        setPack();
        setDialogOpen(true);
    }, []);

    const handleEdit = useCallback(pack => {
        setPack(pack);
        setDialogOpen(true);
    }, []);

    const handleDialogClose = useCallback(() => {
        setPack();
        setDialogOpen(false);
    }, []);

    if (!packs) return <LoadingIndicator />;

    return (
        <Page id="membership-packs">
            <Page.Header
                title="Пакеты"
                breadcrumbs={[
                    { content: 'Абонементы', to: '/memberships' }
                ]}
                actions={[
                    {
                        key: 'add',
                        icon: 'add',
                        content: 'Создать пакет',
                        variant: 'solid',
                        onClick: handleCreate
                    }
                ]}
            />

            <Page.Content>
                <Page.Section
                    variant="outlined"
                    compact
                >
                    <MembershipPacksTable
                        packs={packs}
                        onToggle={togglePack}
                        onEdit={handleEdit}
                        onDelete={deletePack}
                    />
                </Page.Section>
            </Page.Content>

            <FormDialog
                title={pack?.id ? 'Изменить пакет' : 'Новый пакет'}
                form="membership-pack-form"
                open={isDialogOpen}
                onClose={handleDialogClose}
            >
                <MembershipPackForm
                    pack={pack}
                    onSubmit={pack?.id ? updatePack : createPack}
                />
            </FormDialog>
        </Page>
    );
}